import axios from "axios";
import {
  ajaxErrorHandler,
  createServerEndpoint,
  extractAJAXErrorValues
} from "@/utils/functions";
import ROUTE_URL from "@/router/router-constants";
import ERRORS from "@/static/error-constants";

const state = () => ({
    embedParams: null,
    loading: false,
    pageLoadingError: null
});

const getters = {
    loading(state: any): boolean {
        return state.loading;
    }
};

const mutations = {
    UPDATE_AML_EMBED_PARAMS(state: any, payload: any) {
        state.embedParams = payload;
    },
    REGISTER_LOADING(state: any, payload: boolean) {
        state.loading = payload;
    },
    REGISTER_PAGE_LOAD_ERROR(state: any, payload: any) {
        state.pageLoadingError = payload;
    }
};

const actions = {
    async FETCH_AML_EMBED_PARAMS({ commit }: any) {
        commit('REGISTER_LOADING', true);

        let result: any;
        try {
            const { data } = await axios.post<any>(
                createServerEndpoint(ROUTE_URL.ACTION_TOKEN_AML)
            );
            result = data;
            const error = data
                ? null
                : {
                    code: 500,
                    summary: ERRORS.LOAD_ERROR
                };
            commit('REGISTER_PAGE_LOAD_ERROR', error);
        } catch (error: any) {
            const extracted = extractAJAXErrorValues(error);
            const formattedError = ajaxErrorHandler(extracted);

            console.error('Error fetching AML embed params:', error);
            result = null;
            commit('REGISTER_PAGE_LOAD_ERROR', formattedError);
        }
        commit('UPDATE_AML_EMBED_PARAMS', result);
        commit('REGISTER_LOADING', false);
        return result;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};